import React from 'react';
import * as S from './CustomRadioButtonUI.styles';

type RadioBtnProps = {
  isActive?: boolean;
  isCheckMark?: boolean;
  borderColor?: string;
  backgroundColor?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  value?: string;
}

const CustomRadioButton = ({
  isActive,
  isCheckMark = false,
  borderColor,
  backgroundColor,
  onChange,
  name,
  value
}: RadioBtnProps) => {
  return (
    <S.RadioLabel>
      <S.RadioInput 
        type="radio" 
        checked={isActive} 
        onChange={onChange || (() => {})}
        name={name}
        value={value}
        borderColor={borderColor}
      />
      {(isCheckMark && (
        <S.Checkmark></S.Checkmark>
      ) || (
        <S.Dot backgroundColor={backgroundColor}></S.Dot>
      ))}
    </S.RadioLabel>
  )
}

export default CustomRadioButton;  